import { render } from "./UserPlus.vue?vue&type=template&id=5f8d5693"
import script from "./UserPlus.vue?vue&type=script&setup=true&lang=js"
export * from "./UserPlus.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/UserPlus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f8d5693"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f8d5693', __exports__)) {
    api.reload('5f8d5693', __exports__)
  }
  
  module.hot.accept("./UserPlus.vue?vue&type=template&id=5f8d5693", () => {
    api.rerender('5f8d5693', render)
  })

}


export default __exports__